<template>
<!--    <section v-if="!isHomeschoolStore" id="hero" class="h-75" v-bind:style="{ backgroundImage: 'url(' + backgroundImage + ')' }">-->
<!--            <div class="overlay h-100">-->
<!--                <div class="container h-100 d-flex text-white py-lg-5">-->
<!--                    <div class="align-self-center py-lg-5">-->
<!--                        <h2 class="m-0">Award Winning Social Studies.</h2>-->
<!--                        <p class="lead m-0 my-3 w-75">Our Social Studies curriculum gets your students deeper into history and integrates with language arts.</p>-->
<!--                        <a href="https://www.studiesweekly.com/product/social-studies/" class="btn btn-light" target="_blank">-->
<!--                            Learn More <font-awesome-icon :icon="['far', 'angle-right']" />-->
<!--                        </a>-->
<!--                        <router-link :to="{name: 'social-studies', params: {subject: 'social-studies'}}" class="btn btn-primary ml-2">-->
<!--                            Buy Now <font-awesome-icon :icon="['far', 'angle-right']" />-->
<!--                        </router-link>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </section>-->
    <section>
        <div v-if="!isHomeschoolStore" id="hero" class="h-75" v-bind:style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
            <div class="overlay h-100">
                <div class="container h-100 d-flex text-white py-lg-5">
                    <div class="align-self-center py-lg-5">
                        <h2 class="m-0">Award Winning Social Studies.</h2>
                        <p class="lead m-0 my-3 w-75">Our Social Studies curriculum gets your students deeper into history and integrates with language arts.</p>
                        <a href="https://www.studiesweekly.com/social-studies/" class="btn btn-light" target="_blank">
                            Learn More <font-awesome-icon :icon="['far', 'angle-right']" />
                        </a>
                        <router-link :to="{name: 'social-studies', params: {subject: 'social-studies'}}" class="btn btn-primary ml-2">
                            Buy Now <font-awesome-icon :icon="['far', 'angle-right']" />
                        </router-link>
                    </div>
                </div>
            </div>
<!--            <div class="d-flex w-100 align-items-center justify-content-center school_banner text-white">-->
<!--                <span class="pt-3 pb-2"><b-button variant="link" style="color:white" to="#homeschool">are you a homeschool? click here</b-button></span>-->
<!--            </div>-->
        </div>
        <div v-if="isHomeschoolStore" class="text-white">
<!--            <div style='background-image: url("//cdn.studiesweekly.com/store/SWM_0154.png");'>-->
<!--                <div class="container pt-5 lead">-->
<!--                    <h2>Empower your child through Social Studies, Science, and Health & Wellness</h2>-->
<!--                    <p>With Studies Weekly, your children explore their world, connect their learning across topics and become more excited, active citizens.</p>-->
<!--                    <p>Plus, our kid-friendly periodicals and a safe online learning platform make it so they can learn anywhere, anytime.</p>-->

<!--                    <div class="py-3">-->
<!--                        <b-button variant="light" class="mr-4" href="https://samples.studiesweekly.com/homeschool/" target="_blank">Learn More</b-button>-->
<!--&lt;!&ndash;                        <b-button variant="primary">Buy Now</b-button>&ndash;&gt;-->
<!--                    </div>-->
<!--                    <div id="homeschool_img" class="d-flex justify-content-center pt-5">-->
<!--&lt;!&ndash;                        <img src="//cdn.studiesweekly.com/store/Kidspointing.png">&ndash;&gt;-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="d-flex w-100 align-items-center justify-content-center school_banner">
                <span class="pt-3 pb-2">HOMESCHOOL STORE <b-button variant="link" style="color:white" to="#school">not a homeschool? click here</b-button></span>
            </div>
        </div>
    </section>

</template>

<style lang="scss" scoped>
    .form-control {
        min-height: 2.5rem;
    }
    .overlay {
        background-color: rgba(0, 0, 0, .33);
        // text-shadow: 0 0 20px #333;
    }

    #hero {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    #homeschool_img {
        min-height: 200px;
    }

    .school_banner {
        background-color: #00A0AF;
        min-height: 50px;
        font-size: 1.5rem;
        font-weight: 100;
    }

</style>

<script>
import {mapGetters} from 'vuex';
export default {
    data: () => ({
        editor: null
    }),
    props: ['block'],
    components: {

    },
    computed: {
        backgroundImage () {
            var backgroundImage = null
            if (
                this.block.bgImage.startsWith('http://') ||
                this.block.bgImage.startsWith('https://') ||
                this.block.bgImage.startsWith('//')
            ) {
                backgroundImage = this.block.bgImage
            } else {
                backgroundImage = '//' + this.block.bgImage
            }
            return backgroundImage
        },
        ...mapGetters({isHomeschoolStore: 'isHomeschoolStore'})
    },
    methods: {

    },
    mounted () {

    },
}
</script>

